import { useCallback, useState } from 'react';

import { listNoticeCompanyChangeRequests } from '../../../../../api/theHive/notices';
import { ChangeRequestStatus } from '../../../../../api/theHive/notices/enumerations';
import { ChangeRequestData } from '../../../../../api/theHive/notices/types';
import { Constants } from '../../../../../constants/hiveNotices';
import useErrorMessage from '../../../../../hooks/useErrorMessage';
import useSnackbar from '../../../../../hooks/useSnackbar';

interface UseMemberChangeRequestsHook {
  changeRequests: ChangeRequestData[];
  fetchChangeRequests: () => Promise<void>;
}

export default function useMemberChangeRequests(
  noticeCompanyId: number,
  noticeCompanyUserId: number | undefined
): UseMemberChangeRequestsHook {
  const [changeRequests, setChangeRequests] = useState<ChangeRequestData[]>([]);

  const { getErrorMessage } = useErrorMessage();
  const { handleSnackbar } = useSnackbar();

  const fetchChangeRequests = useCallback(async (): Promise<void> => {
    if (!noticeCompanyUserId) return;

    try {
      const response = await listNoticeCompanyChangeRequests({
        noticeCompanyId,
        noticeCompanyUserId,
        status: [ChangeRequestStatus.PENDING],
      });

      if (
        response instanceof Error ||
        response.detail.description ||
        !response.data
      ) {
        throw new Error(Constants.memberRequestsLoadError);
      }

      setChangeRequests(response.data);
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    }
  }, [noticeCompanyId, noticeCompanyUserId, getErrorMessage, handleSnackbar]);

  return { changeRequests, fetchChangeRequests };
}
